import { render, staticRenderFns } from "./ActionInsertLink.vue?vue&type=template&id=05e4c2f2&scoped=true&"
import script from "./ActionInsertLink.vue?vue&type=script&lang=js&"
export * from "./ActionInsertLink.vue?vue&type=script&lang=js&"
import style0 from "./ActionInsertLink.vue?vue&type=style&index=0&id=05e4c2f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e4c2f2",
  null
  
)

export default component.exports